import SimpleBar from 'simplebar'

export const getSimpleBar = (elem) => {
  const sb = new SimpleBar(elem)
  return sb
}
